import CefEvent from './CefEvent.vue'
export default CefEvent

// CEF_DEBUG_MODE = set to true to debug locally (code checks this and it can only be used on dev)
// shows colored boxes and box outlines etc in CEF display
// you can also click on elements to console.log some info (eg rect)
const CEF_DEBUG_MODE = false
export { CEF_DEBUG_MODE }
